import { transparentize } from 'polished';
import styled from 'styled-components';

import { FocusButton } from '@main/pc-core-components/src/FocusButton';
import { sp } from '@main/theme';

export const ListWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeaderWrapper = styled.h3`
  font-size: ${sp(2.8)};
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  margin-bottom: ${sp(2)};
`;

export const SubjectsListWrapper = styled.div`
  width: 220px;
`;

export const FocusButtonWrapper = styled(FocusButton)`
  display: block;
  width: 100%;
  margin-bottom: ${sp(1)};
  border-radius: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`;

/** Subject Wrapper props */
export interface SubjectWrapperProps {
  /** indicates active data subject styling should be used */
  active: boolean;
}

export const SubjectWrapper = styled.div<SubjectWrapperProps>`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black};
  border: 1px solid
    ${({ active, theme }) =>
      active ? theme.colors.primary : theme.colors.highlight};
  box-sizing: border-box;
  text-align: center;
  border-radius: 6px;
  padding: ${sp(0.5)};
  transition: all 0.3s;
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  background: ${({ active, theme }) =>
    active ? transparentize(0.05, theme.colors.highlight) : 'inherit'};
  &:hover {
    background: ${({ active, theme }) =>
      !active
        ? transparentize(0.1, theme.colors.highlight)
        : transparentize(0.05, theme.colors.highlight)};
  }
`;
